const factory = Model => {
  class ClientRequest extends Model {
    $url(id) {
      return `${this.$resource}.json/client/${this.clientId}/request/${id || ''}`;
    }

    $put(data) {
      this.$set(data);
      return super.$put();
    }

    $updateStatus(status) {
      return this.$apiCall({
        method: 'PUT',
        url: `${this.$url(this.id)}/status/${status}`,
      }).then(res => {
        this.$set({ status });
        return res;
      });
    }
  }

  ClientRequest.prototype.$resource = 'clientrequest';
  ClientRequest.prototype.id = null;
  ClientRequest.prototype.$idSerializers = ['clientId', 'id'];

  return ClientRequest;
};

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.clientRequest', moduleDeps)
  .factory('ClientRequest', factory);
